import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main functions" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("pre", null, [
  /*#__PURE__*/_createTextVNode("      "),
  /*#__PURE__*/_createElementVNode("code", { class: "language-javascript" }, "\n        import {\n          currencies, // Array of object currencies\n          fractionToInt, \n          intToFraction, \n          displayValue, \n          getLocale // Will output a string based upon your local language\n        } from 'fp-money'\n      "),
  /*#__PURE__*/_createTextVNode("\n    ")
], -1)
const _hoisted_3 = { class: "section" }
const _hoisted_4 = { class: "item" }
const _hoisted_5 = { class: "item" }
const _hoisted_6 = { class: "item" }
const _hoisted_7 = { class: "item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, "fractionToInt(value, fraction): 86753.09 - " + _toDisplayString(_ctx.fractionToInt(86753.09, 2)), 1),
      _createElementVNode("div", _hoisted_5, "intToFraction(value, fraction): 8675309 - " + _toDisplayString(_ctx.intToFraction(8675309, 2)), 1),
      _createElementVNode("div", _hoisted_6, "displayValue(value, currency, fraction, locale): 86753.09 - " + _toDisplayString(_ctx.displayValue(86753.09, 'usd', 2, 'en-us')), 1),
      _createElementVNode("div", _hoisted_7, "getLocale(): " + _toDisplayString(_ctx.getLocale()), 1)
    ])
  ]))
}